import { connect } from 'react-redux';
import React, { Component } from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';

import { dmarcAuthIsLoadingSelector } from '../../selectors/dmarc-auth-selectors';
import { fetchDmarcAuthenticationIfNeeded } from '../../actions/dmarc-authentication-action-creators';
import { getAdjustedEndDate } from '../../../utils/report-utils';
import {
    reportHeaderSelector,
    selectedDateOptionSelector,
    selectedDomainSelector,
    selectedEndDateSelector,
    selectedIntervalSelector,
    selectedStartDateSelector
} from '../../selectors/reports-selectors';
import DmarcAuthProgressBulletsContainer from
    './dmarc-auth-progress-bullets-container';
import DmarcAuthTableContainer from './dmarc-auth-table-container';
import DmarcAuthVisContainer from './dmarc-auth-vis-container';
import ReportingCard from '../../components/reporting-card';

export class DmarcAuthSectionContainer extends Component{
    constructor( props ){
        super( props );
        const { selectedStartDate, selectedEndDate, selectedInterval, selectedDateRange } = this.props;
        const endDate = getAdjustedEndDate( selectedDateRange, selectedInterval, selectedEndDate );
        const params = {
            endDate: endDate,
            interval: selectedInterval,
            startDate: selectedStartDate,
        };

        this.fetchData( params );
    };

    componentDidUpdate( prevProps ){
        const { selectedStartDate, selectedEndDate, selectedInterval, selectedDomain, selectedDateRange } = this.props;
        if( _.isEqual( selectedStartDate, prevProps.selectedStartDate ) ||
            _.isEqual(  selectedEndDate, prevProps.selectedEndDate ) ||
            _.isEqual( selectedInterval, prevProps.selectedInterval ) ||
            _.isEqual( selectedDomain, prevProps.selectedDomain ) ){
            const endDate = getAdjustedEndDate( selectedDateRange, selectedInterval, selectedEndDate );
            const params = {
                endDate: endDate,
                interval: selectedInterval,
                startDate: selectedStartDate,
            };
            this.fetchData( params );
        };
    };

    fetchData = ( params ) => {
        const { selectedDomain, fetchDmarcAuthenticationIfNeeded } = this.props;
        if( selectedDomain && params ){
            params.domain = selectedDomain;
        };

        fetchDmarcAuthenticationIfNeeded( params );
    };

    render(){
        const { dmarcAuthDataIsLoading, header } = this.props;

        return (
            <ReportingCard
                header={ header }
                dataIsLoading={ dmarcAuthDataIsLoading }
                type={ 'authentication' }
                allowDownload={ true }
                order={ 1 }
                content={{
                    footer: '',
                    leftContent: <DmarcAuthProgressBulletsContainer />,
                    legend: {
                        dotLabel: 'Authorized Email DMARC Pass Rate (%)',
                        streamLabel: 'Authorized Email Volume'
                    },
                    rightContent: <DmarcAuthVisContainer
                        isLoading={ dmarcAuthDataIsLoading }
                    />,
                    subtitle: 'Emails sent to consumer mailbox providers',
                    table: <DmarcAuthTableContainer />,
                    textheader: 'How well did our authorized email to consumer mailbox providers pass (DMARC) authentication?',
                    title: 'Authorized Email DMARC Pass Rate',
                }}
            />
        );
    };
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        dmarcAuthDataIsLoading: dmarcAuthIsLoadingSelector( state ),
        header: reportHeaderSelector( state ),
        selectedDateRange: selectedDateOptionSelector( state ),
        selectedDomain: selectedDomainSelector( state ),
        selectedEndDate: selectedEndDateSelector( state ),
        selectedInterval: selectedIntervalSelector( state ),
        selectedStartDate: selectedStartDateSelector( state ),
    };
};

DmarcAuthSectionContainer.propTypes = {
    dmarcAuthDataIsLoading: PropTypes.bool.isRequired,
    fetchDmarcAuthenticationIfNeeded: PropTypes.func.isRequired,
    header: PropTypes.object.isRequired,
    onInitialLoad: PropTypes.func.isRequired,
    selectedDateRange: PropTypes.string,
    selectedDomain: PropTypes.string,
    selectedEndDate: PropTypes.string.isRequired,
    selectedInterval: PropTypes.string,
    selectedStartDate: PropTypes.string.isRequired,
};

export default connect( mapStateToProps, { fetchDmarcAuthenticationIfNeeded } )( DmarcAuthSectionContainer );
